import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Grid,
  Button,
  TextField,
  FormControl,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useHistory } from 'react-router-dom';

const OrdenValidadaModal = ({ open, onClose, dataOrden }) => {
  const history = useHistory();

  const handleClose = () => {
    if (onClose) onClose();
  };

  const handleIrAlHome = () => {
    handleClose();
    history.push('/');
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle id='alert-dialog-title'>
        <Grid
          container
          direction='row'
          justifyContent='flex-start'
          alignItems='felx-end'
          spacing={1}
        >
          <Grid item>
            {' '}
            <Typography variant='h6'>Orden Validada</Typography>
          </Grid>
          <Grid item>
            {' '}
            <CheckCircleIcon fontSize='small' color='primary'></CheckCircleIcon>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent sx={{ py: 3 }}>
        <Grid container spacing={2}>
          {dataOrden?.numeroOrden && (
            <Grid item xs={12}>
              <FormControl fullWidth={true} variant='standard' margin='normal'>
                <TextField
                  id='numero-orden'
                  variant='standard'
                  label='Nro. de Orden'
                  defaultValue={dataOrden?.numeroOrden}
                  size='small'
                  fullWidth
                  InputProps={{
                    readOnly: true,
                    style: { fontWeight: 'bold' },
                  }}
                />
              </FormControl>
            </Grid>
          )}

          {dataOrden?.nyaAfiliado && (
            <Grid item xs={12}>
              <FormControl fullWidth={true} variant='standard' margin='normal'>
                <TextField
                  id='afiliado'
                  label='Afiliado'
                  variant='standard'
                  defaultValue={`(${dataOrden?.numeroDocumento}) ${dataOrden?.nyaAfiliado}`}
                  size='small'
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </FormControl>
            </Grid>
          )}

          {dataOrden?.nombrePrestador && (
            <Grid item xs={12}>
              <FormControl fullWidth={true} variant='standard' margin='normal'>
                <TextField
                  id='prestador'
                  label='Prestador'
                  variant='standard'
                  defaultValue={dataOrden?.nombrePrestador}
                  size='small'
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </FormControl>
            </Grid>
          )}
        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 2, justifyContent: 'center' }}>
        <Button
          onClick={handleIrAlHome}
          variant='contained'
          color='primary'
          fullWidth
          size='medium'
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OrdenValidadaModal;
